export interface ChartColorsType {
  oeBlue: string;
  oeBlueDark: string;
  oeBlueLight: string;
  aquaBlue: string;
  pacificDark: string;
  aquaBlueDark: string;
  sunnyOrange: string;
  sunnyOrangeDark: string;
  success: string;
}

export const oeChartColors: ChartColorsType = {
  oeBlue: '#0078FF',
  oeBlueDark: '#005DC8',
  oeBlueLight: '#3393FF',
  aquaBlue: '#00DBD1',
  pacificDark: '#00005C',
  aquaBlueDark: '#00C5BC',
  sunnyOrange: '#FF6600',
  sunnyOrangeDark: '#CC5200',
  success: '#01DB8C',
};
